/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export class PrizeForce extends cc.Component
{
    @property({ visible: true, multiline: true })
    protected prizeName: string = "";
    public get Name(): string { return this.prizeName; }

    @property({ type: cc.Integer, visible: true })
    protected prizeIndex: number = 0;
    public get PrizeIndex(): number { return this.prizeIndex; }
    public set PrizeIndex(value: number) { this.prizeIndex = value; }

    @property({ type: cc.Integer, visible: true })
    protected branchIndex: number = 0;
    public get BranchIndex(): number { return this.branchIndex; }
    public set BranchIndex(value: number) { this.branchIndex = value; }

    @property({ type: cc.Integer, visible: true })
    protected stopDataIndex: number = 0;
    public get StopDataIndex(): number { return this.stopDataIndex; }
    public set StopDataIndex(value: number) { this.stopDataIndex = value; }

    @property({ type: [cc.Integer], visible: true })
    protected bonusScriptList: number[] = [];
    public get BonusScriptList(): number[] { return this.bonusScriptList; }
    public set BonusScriptList(values: number[]) { this.bonusScriptList = values; }
}
